// Common
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Application } from '@modules/common/types/application';

// Types
import { VirtualFolder } from '@modules/messages/types/virtual-folder';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';

@Component({
  selector: 'app-messages2-list-context-menu',
  templateUrl: './messages-context-menu.component.html',
  styleUrls: ['./messages-context-menu.component.less'],
  standalone: false,
})
export class MessagesContextMenuComponent {
  // Input
  @Input() filterKey: VirtualFolder;

  // Outputs
  @Output() change = new EventEmitter<VirtualFolder>();

  protected readonly searchService = inject(AdvancedSearchService);
  protected readonly isAdvancedSearchApplied = toSignal(this.searchService.isAdvancedSearchApplied(Application.mail), {
    initialValue: false,
  });

  selectFilter(filter: VirtualFolder) {
    this.change.emit(filter);
  }
}
